import { isHongKongResident } from "./helpers.js"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import dayjs from "dayjs"

const header = [
	[
		"Template A5 - Number of policies expired, by four Underwriting/ Re-underwriting results, by Place of Residence of Insured Person"
	],
	["Place of Residence", "Standard Plan", "", "", "", "Flexi Plan", "", "", ""],
	[
		"",
		"Standard Offer",
		"Offer with Premium Loading only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE",
		"Standard Offer",
		"Offer with Premium Loading only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE"
	]
]

const rows = payload => [
	[
		"Hong Kong",
		countExpiredStandardOffer(true, payload, "S00027"),
		countExpiredOfferWithLoadings(true, payload, "S00027"),
		countExpiredOfferWithExclusions(true, payload, "S00027"),
		countExpiredOfferWithLoadingsAndExclusions(true, payload, "S00027"),
		countExpiredStandardOffer(true, payload, "F00038"),
		countExpiredOfferWithLoadings(true, payload, "F00038"),
		countExpiredOfferWithExclusions(true, payload, "F00038"),
		countExpiredOfferWithLoadingsAndExclusions(true, payload, "F00038")
	],
	[
		"Others",
		countExpiredStandardOffer(false, payload, "S00027"),
		countExpiredOfferWithLoadings(false, payload, "S00027"),
		countExpiredOfferWithExclusions(false, payload, "S00027"),
		countExpiredOfferWithLoadingsAndExclusions(false, payload, "S00027"),
		countExpiredStandardOffer(false, payload, "F00038"),
		countExpiredOfferWithLoadings(false, payload, "F00038"),
		countExpiredOfferWithExclusions(false, payload, "F00038"),
		countExpiredOfferWithLoadingsAndExclusions(false, payload, "F00038")
	]
]

const countExpiredStandardOffer = (isPlaceOfResidence, payload, plan) => {
	return payload.filter(policy => {
		let insuredPlaceOfResidence = isHongKongResident(
			policy.contractInsured[0].addresses
		)
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			insuredPlaceOfResidence === isPlaceOfResidence &&
			matchPlan &&
			dayjs().isAfter(policy?.endDate) === true
		) {
			return policy
		}
	}).length
}

const countExpiredOfferWithLoadings = (isPlaceOfResidence, payload, plan) => {
	return payload.filter(policy => {
		let resident = isHongKongResident(policy.contractInsured[0].addresses)
		let loadings = policy?.premium?.loadings?.length > 0 ? true : false
		let exclusions = policy?.exclusions?.length > 0 ? true : false
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			loadings === true &&
			exclusions === false &&
			resident === isPlaceOfResidence &&
			matchPlan &&
			dayjs().isAfter(policy?.endDate) === true
		) {
			return policy
		}
	}).length
}

const countExpiredOfferWithExclusions = (isPlaceOfResidence, payload, plan) => {
	return payload.filter(policy => {
		let resident = isHongKongResident(policy.contractInsured[0].addresses)
		let exclusions = policy?.exclusions?.length > 0 ? true : false
		let loadings = policy?.premium?.loadings?.length > 0 ? true : false
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			exclusions === true &&
			loadings === false &&
			resident === isPlaceOfResidence &&
			matchPlan &&
			dayjs().isAfter(policy?.endDate) === true
		) {
			return policy
		}
	}).length
}

const countExpiredOfferWithLoadingsAndExclusions = (
	isPlaceOfResidence,
	payload,
	plan
) => {
	return payload.filter(policy => {
		let resident = isHongKongResident(policy.contractInsured[0].addresses)
		let loadings = policy?.premium?.loadings?.length > 0 ? true : false
		let exclusions = policy?.exclusions?.length > 0 ? true : false
		let matchPlan = policy?.product?.productId?.plan?.includes(plan)
		if (
			policy.status === "ISSUED" &&
			loadings &&
			exclusions &&
			resident === isPlaceOfResidence &&
			matchPlan &&
			dayjs().isAfter(policy?.endDate) === true
		) {
			return policy
		}
	}).length
}

const fetchData = async filterPayload => {
	const query = gql`
		query fetchTemplateA5Payload($policyWhere: policyWhereInput) {
			policies(where: $policyWhere) {
				list {
					status
					endDate
					product {
						productId {
							plan
						}
					}
					contractInsured {
						... on individual {
							gender
							dateOfBirth
							addresses {
								id
								type
								fields2 {
									type
									value
								}
							}
						}
					}
					premium {
						loadings {
							id
						}
					}
					exclusions {
						id
					}
				}
			}
		}
	`
	const variables = {
		policyWhere: filterPayload
	}

	const res = await api({ query, variables })

	return res?.data?.policies?.list
}

export default async filterPayload => {
	const fetchedData = await fetchData(filterPayload)
	const workSheetData = [...header, ...rows(fetchedData)]
	const workSheetColumns = header[1].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 1, c: 0 },
			e: { r: 2, c: 0 }
		},
		{
			s: { r: 1, c: 1 },
			e: { r: 1, c: 4 }
		},
		{
			s: { r: 1, c: 5 },
			e: { r: 1, c: 8 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}
